module.exports = __webpack_public_path__ + "img/services-details-1.21ab497a.jpg";